/** Age in whole days. */
export function ageDays(iso: string | null): number | null {
  if (!iso) return null;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000));
}

/** 100 when the newest post is a day old or less, falling to 0 at 14 days. A wall over 7 days is stale. */
export function freshnessScore(newestIso: string | null): number {
  const age = ageDays(newestIso);
  if (age === null) return 0;
  return Math.round(Math.max(0, Math.min(100, 100 - Math.max(0, age - 1) * (100 / 13))));
}

export function ageLabel(iso: string | null) {
  const d = ageDays(iso);
  if (d === null) return "";
  return d === 0 ? "today" : `${d}d`;
}
